import React from "react";
import { AnimatePresence, motion } from "framer-motion";

export const SidebarSection = ({ label, collapsed, isMobile = false, children }) => {
  const hideLabel = collapsed && !isMobile;

  return (
    <div className="mt-4">
      <AnimatePresence mode="wait">
        {hideLabel ? (
          <motion.div
            key={`${label}-divider`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="mx-4 border-t border-gray-200"
          />
        ) : (
          <motion.div
            key={`${label}-label`}
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -4 }}
            className="px-4 py-1 text-xs font-semibold uppercase tracking-wider text-gray-400"
          >
            {label}
          </motion.div>
        )}
      </AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
      >
        {children}
      </motion.div>
    </div>
  );
};
